/**
 * Barre d'actions pour la sélection multiple
 */
import React, { memo } from 'react';

const SelectionBar = memo(({ count, onQualify, onCancel }) => {
  if (count === 0) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #6f42c1, #5a32a3)',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '8px',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '10px'
    }}>
      <span style={{ fontWeight: '600' }}>
        {count} client(s) selectionne(s)
      </span>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={onQualify}
          style={{
            padding: '8px 16px',
            background: 'white',
            color: '#6f42c1',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          Qualifier en masse
        </button>
        <button
          onClick={onCancel}
          style={{
            padding: '8px 16px',
            background: 'rgba(255,255,255,0.2)',
            color: 'white',
            border: '1px solid white',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Annuler
        </button>
      </div>
    </div>
  );
});

SelectionBar.displayName = 'SelectionBar';

export default SelectionBar;
